import { render, staticRenderFns } from "./tagsMgmt.vue?vue&type=template&id=1bbdc693&scoped=true&"
import script from "./tagsMgmt.vue?vue&type=script&lang=js&"
export * from "./tagsMgmt.vue?vue&type=script&lang=js&"
import style0 from "./tagsMgmt.vue?vue&type=style&index=0&id=1bbdc693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdc693",
  null
  
)

export default component.exports